import React from "react";

import { addressValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function RegistrationStreet(props: { labelClassName?: string }) {
	const { labelClassName } = props;

	return (
		<FormInputField
			className="form__field"
			name="street"
			label="registration:STREET_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:STREET_PLACEHOLDER"
			pattern={{
				value: addressValidationPattern,
				message: "registration:STREET_CHARACTER",
			}}
			required
		/>
	);
}
